<template>
  <div class="f360-inline-banner">
    <PBannerBase :error="variant === 'error'" :warning="variant === 'warning'">
      <template #title>
        <span v-if="title" class="f360-inline-banner__title">
          {{ title }}
        </span>
        <span v-else class="f360-inline-banner__text">
          <slot />
        </span>
      </template>

      <!-- Slot condicional: o PBannerBase 1.0.0 renderiza o __content (com
      margin-top) sempre que recebe default slot, mesmo vazio. -->
      <template v-if="title" #default>
        <div class="f360-inline-banner__content">
          <slot />
        </div>
      </template>
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";

withDefaults(
  defineProps<{
    variant?: "default" | "info" | "error" | "warning";
    title?: string;
  }>(),
  {
    variant: "default"
  }
);
</script>

<style scoped lang="scss">
.f360-inline-banner {
  margin-bottom: var(--prisma-space-sm);

  &__text,
  &__title,
  &__content {
    font-family: var(--prisma-font-family);
  }

  &__text {
    // TODO[FINC-1805]: trocar por token do Prisma quando houver um de 13px;
    // é o tamanho do banner informativo original do painel de integrações.
    font-size: 13px;
    font-weight: 400;
    line-height: var(--prisma-line-height-normal);
  }

  &__title {
    font-size: var(--prisma-font-size-small);
    font-weight: 600;
    line-height: var(--prisma-line-height-normal);
  }

  &__content {
    color: var(--prisma-text-color-regular);
    font-size: var(--prisma-font-size-small);
    font-weight: 400;
    line-height: var(--prisma-line-height-normal);
  }
}
</style>
